import { ComponentElementsColors } from '../graphql/generated/graphql';
type Colors = { [key: string]: string };

let colorMap: Colors = {
  gray: 'gray-300',
  dark: 'gray-700',
  slate: 'slate-200',
  white: 'white',
  text: 'gray-900',
};

export function setColors(colors: Colors) {
  colorMap = { ...colorMap, ...colors };
}

export function getColorClassName(color?: null | string): string {
  if (!color) return '';
  return colorMap[color] || color || 'gray-400';
}

export function getColors(color?: ComponentElementsColors | null) {
  if (!color) {
    return {
      backgroundColorClassName: '',
      textColorClassName: '',
    };
  }

  const bgColor = getColorClassName(
    color.backgroundColor?.data?.attributes?.value,
  );
  const textColor = getColorClassName(color.textColor?.data?.attributes?.value);

  return {
    backgroundColorClassName: bgColor ? `bg-${bgColor}` : '',
    textColorClassName: textColor ? `text-${textColor}` : '',
  };
}
